export default __webpack_public_path__ + "images/referenzen/werbespot/dominos_club_tvc.mp4";